import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { FaSearch, FaBars, FaTimes } from "react-icons/fa";
import InvertColorsButton from "./invert"
import "../Css/navbar.css";

const Navbar = ({ onScrollToNosotros, onScrollToProyectos, onScrollToProceso, onScrollToPlanes }) => {
    const [query, setQuery] = useState("");
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            setScrolled(window.scrollY > 10); // adjust value to your needs
        };

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);



    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };
    function useIsSmallScreen() {
        const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 460);

        useEffect(() => {
            const handleResize = () => {
                setIsSmallScreen(window.innerWidth < 460);
            };

            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []);

        return isSmallScreen;
    }
    const isSmallScreen = useIsSmallScreen();

    return (
        <nav className={`navbar ${scrolled ? "navbar-scrolled" : ""}`}>
            <div className="container-nav">
                <div className="Container-left">
                    <a className="logo-container" href="/"><img src={"/Logos/logo.svg"} width={50} alt="ClustTec" /></a>
                </div>

                <button className="menu-toggle" onClick={toggleMenu}>
                    {menuOpen ? <FaTimes /> : <FaBars />}
                </button>
                <div className="navl-container">
                    <div className={`nav-links ${menuOpen ? "open" : ""}`}>
                        <div className="Text">
                            <Link to="/"><h3 className="Normal-btn" onClick={()=>{toggleMenu();onScrollToNosotros();}}>Nosotros</h3></Link>
                            <Link to="/"><h3 className="Normal-btn" onClick={()=>{toggleMenu();onScrollToProyectos();}}>Proyectos</h3></Link>
                            {/* <Link to="/"><h3 className="Normal-btn" onClick={onScrollToProceso}>Proceso</h3></Link>
                        <Link to="/"><h3 className="Normal-btn" onClick={onScrollToPlanes}>Planes</h3></Link> */}


                            {/* <InvertColorsButton /> */}
                            {isSmallScreen && <Link to="/contacto"><h3 className="Normal-btn">Programá una reunión</h3></Link>}
                        </div>
                    </div>
                </div>
                {!isSmallScreen && <Link to="/contacto"><h3 className="Agenda-btn">Programá una reunión</h3></Link>}
            </div>
        </nav>
    );
};

export default Navbar;
